/**
 * Revelado al hacer scroll: las secciones entran cuando llegan, no estan ya.
 *
 * POR QUE EXISTE. Fran, 10/09 por la noche: «quiero que anadas mas animaciones
 * para que todo este mas profesional y en sintonia». La portada tenia
 * movimiento donde hay interaccion -el bote que gira, la baldosa que se abre,
 * la cinta de movil- y nada al recorrerla: cada seccion estaba ya puesta al
 * llegar. Esto anade un solo gesto, el mismo en toda la tienda: lo que entra
 * en pantalla sube 14 px y aparece, y lo que va en fila -baldosas, pasos,
 * preguntas- lo hace de uno en uno con 70 ms de diferencia.
 *
 * ES UNA MEJORA, NO UN REQUISITO. Nada se esconde hasta que este script marca
 * `data-nn-revela` en <html>; si no carga, si el navegador no tiene
 * IntersectionObserver o si la persona pide menos movimiento, la pagina se
 * pinta entera y quieta, que es como estaba.
 *
 * TRES DECISIONES QUE CONVIENE CONOCER:
 *
 * 1. Lo que ya se ve al cargar no se anima. Se mide antes de esconder nada y
 *    se marca como visto en el mismo tirón; asi el primer pintado es completo y
 *    no hay parpadeo. El hero tiene su propia entrada en CSS (por eso se salta
 *    aqui): es lo primero que se ve y no hay scroll que lo dispare.
 * 2. Se anima el hijo, no la seccion. Un bloque de texto, cada baldosa de una
 *    rejilla, cada dato de una franja, cada pregunta del FAQ. Animar la banda
 *    entera es una cortina; animar sus piezas es un orden de lectura.
 * 3. No se toca el cuestionario (`.nn-test`): sus pantallas ya entran y salen
 *    con su propio JS, y dos animaciones encima de lo mismo se pisan.
 *
 * Horizon hace scroll en `.page-wrapper` en escritorio y en el documento en
 * movil; a IntersectionObserver con `root: null` le da igual, mide contra la
 * ventana.
 */
(() => {
  const QUIETO = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (QUIETO.matches || !('IntersectionObserver' in window)) return;

  const html = document.documentElement;

  /** Contenedores cuyos HIJOS son las piezas, de uno en uno. */
  const REPARTE_HIJOS = '.nn-rejilla, .nn-articulos, .nn-franja, .nn-voces__lista, .resource-list--grid';

  /** Lo que merece bajar un nivel para encontrar: lo de arriba y el acordeon. */
  const REPARTO = `${REPARTE_HIJOS}, .accordion`;

  /**
   * Las piezas a revelar dentro de un contenedor, con su orden. Se baja por los
   * grupos del editor hasta dar con algo que se reparta: en la landing, el
   * titular y la rejilla de pasos van dentro de un mismo grupo, y si el grupo
   * fuera la pieza, los tres pasos entrarian de golpe como una cortina.
   */
  const piezasDe = (contenedor, salida = []) => {
    for (const hijo of contenedor.children) {
      if (hijo.matches(REPARTE_HIJOS)) {
        [...hijo.children].forEach((pieza, i) => salida.push([pieza, i]));
      } else if (hijo.matches('.accordion')) {
        [...hijo.querySelectorAll('.details')].forEach((fila, i) => salida.push([fila, i]));
      } else if (hijo.querySelector(REPARTO)) {
        // Un grupo con algo repartible dentro: se baja un nivel. El grupo de
        // Horizon envuelve a sus hijos en `.group-block-content`; si no lo
        // trae, se baja por el propio grupo.
        piezasDe(hijo.querySelector(':scope > .group-block-content') || hijo, salida);
      } else {
        salida.push([hijo, 0]);
      }
    }
    return salida;
  };

  const candidatos = () => {
    const salida = [];
    const bandas = document.querySelectorAll(
      '.nn-banda:not(.nn-banda--bajo-cabecera) > .nn-banda__contenido'
    );
    for (const contenido of bandas) {
      if (contenido.querySelector('.nn-test')) continue;
      piezasDe(contenido, salida);
    }
    // Las franjas sueltas, fuera de una banda (la de «Por donde empiezo»).
    for (const franja of document.querySelectorAll('.nn-franja')) {
      if (franja.closest('.nn-banda__contenido')) continue;
      [...franja.children].forEach((pieza, i) => salida.push([pieza, i]));
    }
    // Las tarjetas de «Vuestros favoritos», que no viven en una banda. Cada
    // panel de pestana lleva su rejilla; las de los paneles escondidos no
    // tienen caja al cargar y quedan pendientes, asi que al cambiar de pestana
    // entran escalonadas, que es el unico movimiento que tiene ese cambio.
    for (const rejilla of document.querySelectorAll('.nn-pestanas .resource-list--grid')) {
      [...rejilla.children].forEach((pieza, i) => salida.push([pieza, i]));
    }
    // LA FICHA (Fran, 13/09 por la noche: «anade mas animaciones en la ficha,
    // veo que hay pocas»). Tres cosas que no vivian en una banda o que la banda
    // no repartia: la foto que va al lado del texto («Como se toma», «Los
    // numeros»), que entra con su propio gesto -ver el CSS-; y «Se compra junto
    // con», que es una seccion de Horizon: su titulo y sus tarjetas, de una en
    // una. La tira de opiniones NO se reparte: `natnatura-resenas.js` clona
    // sus piezas para el bucle y una copia de una pieza aun no vista se
    // quedaria escondida sin nadie que la observara; entra entera. Lo de arriba del todo -galeria y columna de compra- se ve al cargar
    // y entra por animacion CSS, como el hero.
    for (const lado of document.querySelectorAll('.nn-banda > .nn-banda__lado')) {
      salida.push([lado, 0]);
    }
    for (const seccion of document.querySelectorAll('product-recommendations')) {
      const lista = seccion.querySelector('.resource-list');
      for (const cabecera of seccion.querySelectorAll(':scope .text-block, :scope h2')) {
        if (cabecera.closest('.resource-list')) continue;
        salida.push([cabecera, 0]);
        break;
      }
      if (lista) [...lista.children].forEach((pieza, i) => salida.push([pieza, i]));
    }
    return salida;
  };

  /**
   * Lo que ya asoma al cargar se da por visto ANTES de esconder nada. Lo que
   * no tiene caja (un panel con `hidden`) no asoma: queda pendiente y el
   * observador lo vera cuando se muestre.
   *
   * Se pregunta a un IntersectionObserver y no con `getBoundingClientRect`
   * pieza a pieza (22/10/2026 por la noche, PageSpeed): medir obligaba a
   * maquetar la pagina entera dentro de este script, y alternar medir y marcar
   * repetia el recalculo de estilos una vez por pieza (46 ms de 56 en la
   * portada con la CPU de PSI). El observador contesta tras el primer
   * fotograma, con la maquetacion que el navegador hace de todos modos, y
   * hasta entonces no se esconde nada (`data-nn-revela` en <html> va despues):
   * se ve exactamente lo mismo.
   *
   * Con la pestana de fondo el observador no contesta hasta que se ve; ahi se
   * mide como antes (todo de una vez, y en una pestana oculta no hay prisa):
   * si no, al volver a ella lo de arriba entraria animado.
   */
  const asoma = (caja, alto) => (caja.width > 0 || caja.height > 0) && caja.top < alto;

  const separaYa = (piezas) => {
    const alto = window.innerHeight;
    const vistas = new Set();
    for (const [pieza] of piezas) if (asoma(pieza.getBoundingClientRect(), alto)) vistas.add(pieza);
    return vistas;
  };

  const separa = (piezas) =>
    new Promise((resuelve) => {
      const vistas = new Set();
      const faltan = new Set(piezas.map(([pieza]) => pieza));
      let hecho = false;
      let red = 0;
      const termina = () => {
        if (hecho) return;
        hecho = true;
        window.clearTimeout(red);
        sonda.disconnect();
        resuelve(vistas);
      };
      // La primera vuelta del observador trae una entrada por pieza; se espera
      // a tenerlas todas por si llegaran en mas de un aviso. Si alguna no
      // contestara, a los 500 ms lo que falte queda pendiente (lo vera el
      // observador de abajo), como lo que no tenia caja.
      const sonda = new IntersectionObserver((entradas) => {
        for (const entrada of entradas) {
          if (!faltan.delete(entrada.target)) continue;
          const alto = entrada.rootBounds ? entrada.rootBounds.height : window.innerHeight;
          if (asoma(entrada.boundingClientRect, alto)) vistas.add(entrada.target);
        }
        if (!faltan.size) termina();
        else if (!red) red = window.setTimeout(termina, 500);
      });
      for (const pieza of faltan) sonda.observe(pieza);
    });

  const arranca = async () => {
    const piezas = candidatos();
    if (!piezas.length) return;

    for (const [pieza, orden] of piezas) {
      pieza.setAttribute('data-nn-revela', '');
      pieza.style.setProperty('--nn-orden', String(orden));
    }
    const vistas = document.visibilityState === 'visible' ? await separa(piezas) : separaYa(piezas);
    const pendientes = [];
    for (const [pieza] of piezas) {
      if (vistas.has(pieza)) pieza.setAttribute('data-nn-visto', '');
      else pendientes.push(pieza);
    }
    // A partir de aqui el CSS esconde lo no visto. Mismo tirón, sin pintado
    // intermedio: no hay parpadeo.
    html.setAttribute('data-nn-revela', '');
    if (!pendientes.length) return;

    const observador = new IntersectionObserver(
      (entradas) => {
        for (const entrada of entradas) {
          if (!entrada.isIntersecting) continue;
          entrada.target.setAttribute('data-nn-visto', '');
          observador.unobserve(entrada.target);
        }
      },
      // Un 12 % de la pieza dentro, y 8 % de margen por abajo: entra cuando
      // de verdad se esta mirando, no al rozar el borde.
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    for (const pieza of pendientes) observador.observe(pieza);

    // Si a mitad de visita se pide menos movimiento, todo a la vista y quieto.
    QUIETO.addEventListener('change', () => {
      if (!QUIETO.matches) return;
      observador.disconnect();
      html.removeAttribute('data-nn-revela');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca, { once: true });
  } else {
    arranca();
  }
})();
